import {
    TechRadarApi,
} from '@backstage-community/plugin-tech-radar';

import {
    DiscoveryApi,
    IdentityApi,
    FetchApi,
} from '@backstage/frontend-plugin-api';

import { 
    TechRadarLoaderResponse,
    TechRadarLoaderResponseParser,
} from '@backstage-community/plugin-tech-radar-common';

export type Options = {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
    identityApi: IdentityApi;
};

export class TechRadarClient implements TechRadarApi {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
    identityApi: IdentityApi;

    constructor(opts: Options) {
        this.discoveryApi = opts.discoveryApi;
        this.fetchApi = opts.fetchApi;
        this.identityApi = opts.identityApi;
    }

    async load(): Promise<TechRadarLoaderResponse> {

        const { token: idToken } = await this.identityApi.getCredentials();
        const apiUrl = await this.discoveryApi.getBaseUrl('techradar-md');
        const response = await this.fetchApi.fetch(`${apiUrl}/data`, {
            headers: {
                'Content-Type': 'application/json',
                ...(idToken && { Authorization: `Bearer ${idToken}` }),
            },
        });

        if (response.status === 200) {
            const respJson = await response.json();
            const validationResult =
                TechRadarLoaderResponseParser.safeParse(respJson);
            if (validationResult.success) {
                return validationResult.data;
            }
        }

        throw new Error('Failed to load tech radar data');
    }
}